import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Banner, BannerService } from '../../../services/banner.service';

@Component({
    selector: 'app-banner',
    template: `
    @for (banner of banners$ | async; track banner) {
      <div
        class="banner {{ banner.type }}">
        <div>
          @switch (banner.type) {
            @case ('info') {
              <mat-icon>info</mat-icon>
            }
            @case ('warning') {
              <mat-icon>warning</mat-icon>
            }
            @case ('error') {
              <mat-icon>error</mat-icon>
            }
            @case ('success') {
              <mat-icon>check_circle</mat-icon>
            }
          }
          <span class=title>{{ banner.message }}</span>
          @if (banner.action) {
            <button mat-button
              (click)="handleAction(banner.action)">
              {{ banner.action.text }}
            </button>
          }
        </div>
        <button mat-icon-button
          (click)="dismiss(banner)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }
    `,
    styleUrls: ['./banner.component.scss'],
    standalone: false
})
export class BannerComponent {

    public banners$: Observable<Banner[]>;

    constructor(
        private _bannerService: BannerService,
    ) {
        this.banners$ = this._bannerService.banners$;
    }

    public handleAction(action: Banner['action']) {
        action.callback();
    }

    public dismiss(banner: Banner) {
        this._bannerService.dismiss(banner);
    }

}
